<template>
    <DxDataGrid :data-source="dsOrganigrama" ref="dataGridRef" :allow-column-reordering="false" :allow-column-resizing="true" :column-auto-width="false"
        :show-borders="true" key-expr="Id">
        <DxSelection mode="single" />
        <DxFilterRow :visible="false" />
        <DxPaging :page-size="10" :page-index="0" />
        <DxLoadPanel :enabled="true" :indicator-src="'reload6.gif'" />
        <DxSorting mode="multiple" />
        <DxSearchPanel :visible="true" :width="240" placeholder='Cauta ...'></DxSearchPanel>
        <DxMasterDetail :enabled="true" template="detaliiTemplate" />
        <template #detaliiTemplate="{ data }">
            <div class="master-detail-caption">
                Detalii pentru organigrama: {{ data.data.Nume }}
            </div>
            <GridOrganigramaDetalii :template-data="data" />
        </template>

         <DxEditing :allow-updating="true" :allow-deleting="true" mode="popup">
            <DxPopup :closeOnOutsideClick="false" :showCloseButton="false" width="500px" height="530px" :show-title="true" title-template="editTitle">
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="saveButtonOptions" />
                <DxToolbarItem toolbar="bottom" widget="dxButton" location="center" :options="dangerButtonOptions" />
            </DxPopup>
            <DxFormGrid>
                <DxItem data-field="Cod" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Nume" :editor-options="{ height: 50 }"/>
                <DxItem data-field="StareID" editor-type="dxSelectBox" 
                        :editor-options="{dataSource: dsOrganigrameStari, 
                        displayExpr: 'Nume', 
                        valueExpr: 'Id', 
                        placeholder: 'Selectează o stare...',
                        height: 50,
                        showClearButton: true}"/>
                <DxItem data-field="Versiune" editor-type="dxNumberBox" :editor-options="numberBoxOptions"/> 
                <DxItem data-field="AprobareDocument" :editor-options="{ height: 50 }"/>
                <DxItem data-field="Observatii" :editor-options="{ height: 50 }"/>
                <DxItem data-field="ValidData" :editor-options="{ height: 50, displayFormat: 'dd-MM-yyyy' }"/>
                <DxItem data-field="AprobareData"  :editor-options="{ height: 50, displayFormat: 'dd-MM-yyyy' }"/>
                <DxItem data-field="Valid" editor-type="dxCheckBox" :css-class="'checkbox-center'" :editor-options="{ elementAttr: { style: 'display:flex; justify-content:center; margin-left:120px' } }"/>
            </DxFormGrid>
        </DxEditing>    
        <template #editTitle>
            <div style="background-color:#ff2c21; font-size:15px; color:white; font-weight:bold; padding:10px 0 10px 20px; width:100%;">
                Editare Organigrama
            </div>
        </template>

        <DxColumn data-field="Cod" caption="Cod"/>
        <DxColumn data-field="Nume" caption="Nume"/>
        <DxColumn data-field="StareID" caption="Stare" calculate-display-value="Stare.Nume"/>
        <DxColumn data-field="Versiune" caption="Versiune"/>
        <DxColumn data-field="ValidData" caption="Valid Data" data-type="date"/>
        <DxColumn data-field="Valid" caption="Valid (calculat)"/>
        <DxColumn data-field="AprobareDocument" caption="Aprobare Document"/>
        <DxColumn data-field="AprobareData" caption="Aprobare Data" data-type="date"/>
        <DxColumn data-field="Observatii" caption="Observatii"/>
        <DxColumn caption="Rapoarte" :width="140" :allow-sorting="false" cell-template="raportTpl" />
        <template #raportTpl="{ data }">
            <DxButton icon="exportpdf" text="Stat funcții" styling-mode="text"
                hint="Raport Stat de funcții" @click="raportStatFunctii(data.data.Id)" />
        </template>

        <DxToolbar>
            <DxItem location="after" name="searchPanel"/>
            <DxItem>
                <template #default>
                    <DxButton icon="add" type="success" @click="onAddClick" />
                </template>
            </DxItem>
            <DxItem>
                <template #default>
                    <DxButton icon="refresh" @click="onRefreshClick" />
                </template>
            </DxItem>
        </DxToolbar>
    </DxDataGrid>
    <DxPopupAdd :visible="addPopupVisible" :show-title="true" width="500px" height="500px">
        <template #title>
            <div style="background-color: #ff2c21; font-size: 15px; color: white; font-weight: bold;  padding: 10px; padding-left: 20px; ">
                Adăugare Organigrama
            </div>
        </template>
        <DxForm :col-count="2">
            <DxSimpleItem data-field="Cod" :is-required="true">
                <template #default>
                    <DxTextArea :value="newOrganigrama.Cod" @value-changed="onCodValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Nume" :is-required="true">
                <template #default>
                    <DxTextArea :value="newOrganigrama.Nume" @value-changed="onNumeValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Stare">
                <template #default>
                    <DxLookup :data-source="dsOrganigrameStari"
                              display-expr="Nume"
                              value-expr="Id"
                              :value="newOrganigrama.StareID"
                              @value-changed="onStareIDValueChanged"
                              height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Versiune">
                <template #default>
                    <DxNumberBox :min="0" :step="1" :show-spin-buttons="true" :show-clear-button="true" :value="newOrganigrama.Versiune" @value-changed="onVersiuneValueChanged" height="50px"/>
                </template>
            </DxSimpleItem> 
            <DxSimpleItem data-field="Aprobare Document">
                <template #default>
                    <DxTextArea :value="newOrganigrama.AprobareDocument" @value-changed="onAprobDocValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Observatii">
                <template #default>
                    <DxTextArea :value="newOrganigrama.Observatii" @value-changed="onObservatiiValueChanged" height="50px"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Valid Data">
                <template #default>
                    <DxDateBox :value="newOrganigrama.ValidData" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" @value-changed="onValidDataValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Aprobare Data">
                <template #default>
                    <DxDateBox :value="newOrganigrama.AprobareData" type="date" display-format="dd-MM-yyyy" :show-clear-button="true" 
                    label-mode="floating" height="50px" @value-changed="onAprobDataValueChanged"/>
                </template>
            </DxSimpleItem>
            <DxSimpleItem data-field="Valid (calculat)" :col-span="2">
                <template #default>
                    <div style="display: flex; justify-content: center;">
                        <DxCheckBox :value="newOrganigrama.Valid" @value-changed="onValidValueChanged" />
                    </div>
                </template>
            </DxSimpleItem>
        </DxForm>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="addButtonOptions"/>
        <DxToolbarItem widget="dxButton" toolbar="bottom" location="center" :options="closeButtonOptions"/>
    </DxPopupAdd>
</template>
<script lang="ts">
import {
  DxColumn,
  DxDataGrid,
  DxFilterRow,
  DxLoadPanel,
  DxPaging,
  DxSelection,
  DxSorting,
  DxStateStoring,
  DxToolbar,
  DxEditing,
  DxPopup,
  DxItem,
  DxItem as DxFormItem,
  DxForm as DxFormGrid,
  DxValidationRule,
  DxRequiredRule,
  DxSearchPanel,
  DxMasterDetail
} from 'devextreme-vue/data-grid';
import DxDateBox from 'devextreme-vue/date-box';
import { DxCheckBox } from 'devextreme-vue/check-box';
import DxTextArea from 'devextreme-vue/text-area';
import AppSetting from '@/settings/appSettings';
import { defineComponent, ref } from 'vue';
import DataSource from 'devextreme/data/data_source';
import { DxButton } from 'devextreme-vue/button';
import notify from 'devextreme/ui/notify';
import { DxForm, DxSimpleItem } from "devextreme-vue/form"
import DxPopupAdd from 'devextreme-vue/popup'
import { DxToolbarItem } from 'devextreme-vue/popup';
import { DxLookup } from 'devextreme-vue/lookup';
import { DxNumberBox } from "devextreme-vue/number-box";
import GridOrganigramaDetalii from './GridOrganigramaDetalii.vue';
import RU_Organigrama from '@/services/RU/RU_Organigrama';
import RU_Rapoarte from '@/services/RU/RU_Rapoarte';

export default defineComponent({
    components: {
        DxColumn,
        DxDataGrid,
        DxFilterRow,
        DxLoadPanel,
        DxPaging,
        DxSelection,
        DxSorting,
        DxStateStoring,
        DxToolbar,
        DxEditing,
        DxValidationRule,
        DxRequiredRule,
        DxItem,
        DxButton,
        DxSearchPanel,
        DxForm,
        DxPopupAdd,
        DxSimpleItem,
        DxTextArea,
        DxCheckBox,
        DxToolbarItem,
        DxPopup,
        DxFormGrid,
        DxFormItem,
        DxMasterDetail,
        DxLookup,
        DxNumberBox,
        DxDateBox,
        GridOrganigramaDetalii
    },
    data() {
        return {
            dsOrganigrama: {} as DataSource,
            dataGridRef: null as any,
            dsOrganigrameStari: new DataSource({
                store: {
                    type: 'odata',
                    url: AppSetting.API_Url_ResurseUmaneOdata + `RU_OrganigrameStari`,
                    key: 'Id',
                    keyType: "Guid",
                    version: 4,
                    beforeSend: (e: any) => {
                        e.headers = {
                            "Content-Type": "application/json",
                            "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                        };
                    },
                },
            }),
            stariDict: {} as Record<string, string>,
            newOrganigrama: {
                Cod: '',
                Nume: '',
                StareID: null,
                Versiune: null,
                Valid: null,
                AprobareDocument: null,
                AprobareData: null,
                Observatii: null,
                ValidData: null
            },
            addPopupVisible: false,
            editPopupVisible: false,
            addButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveAdd()
                }
            },
            saveButtonOptions: {
                type: "success", 
                text: "Salvează", 
                stylingMode: "contained",
                onClick: () => {
                    this.onSaveEdit()
                }
            },
            closeButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.onCloseAdd()
                }
            },
            dangerButtonOptions: {
                type: "danger", 
                text: "Închide", 
                stylingMode: "contained",
                onClick: () => {
                    this.closeEditPopup()
                }
            },
            deleteConfirmationMessage: "Sigur doriți să ștergeți această înregistrare?",
            numberBoxOptions: {
                min: 0,
                step: 1,
                showSpinButtons: true,
                showClearButton: true,
                height: 50
            },
        }
    },
    mounted() {
        this.dsOrganigrama = new DataSource({
            store: {
                type: 'odata',
                url: AppSetting.API_Url_ResurseUmaneOdata + `RU_Organigrama`,
                key: 'Id',
                keyType: "Guid",
                version: 4,
                beforeSend: (e: any) => {
                    e.headers = {
                        "Content-Type": "application/json",
                        "Authorization": "Bearer " + localStorage.getItem("ERA_Jwt")
                    };
                    e.params.$expand = "Stare($select=Cod,Nume)"
                },
            } as any,
        })
        this.dataGridRef = this.$refs.dataGridRef as DxDataGrid;
        this.setDeleteConfirmationMessage()
    },
    methods: {
        async raportStatFunctii(organigramaId: string) {
            try {
                const resp = await RU_Rapoarte.raportStatDeFunctii(organigramaId);
                const url = URL.createObjectURL(new Blob([resp.data], { type: 'application/pdf' }));
                const win = window.open(url, '_blank');
                setTimeout(() => URL.revokeObjectURL(url), 60000);
                if (!win) notify('Permiteți pop-up-uri pentru a vizualiza raportul.', 'warning', 4000);
            } catch (e) { console.error(e); notify('Eroare la generarea raportului!', 'error', 3000); }
        },
        onRefreshClick() {
            const gridInstance = this.dataGridRef?.instance;
            if (gridInstance) {
                gridInstance.refresh();
                notify("Datele au fost actualizate cu succes!", "success", 3000);
            }
        },
        setDeleteConfirmationMessage() {
            const dataGrid = this.$refs.dataGridRef?.instance;
            dataGrid.option('editing', {
                allowUpdating: true,
                allowDeleting: true,
                mode: 'popup',
                texts: {
                    confirmDeleteMessage: this.deleteConfirmationMessage,
                    confirmDeleteTitle: "Confirmare Ștergere",
                }
            });
        },
        closeEditPopup() {
            this.dataGridRef?.instance?.cancelEditData();
        },
        onAddClick() {
            this.addPopupVisible = true
        },
        onCloseAdd() {
            this.addPopupVisible = false
            this.newOrganigrama.Cod = ''
            this.newOrganigrama.Nume = ''
            this.newOrganigrama.StareID = null
            this.newOrganigrama.Valid = null
            this.newOrganigrama.Versiune = null
            this.newOrganigrama.AprobareDocument = null
            this.newOrganigrama.AprobareData = null
            this.newOrganigrama.Observatii = null
            this.newOrganigrama.ValidData = null
        },
        async onSaveEdit() {
            const gridInstance = this.dataGridRef?.instance;
            if (!gridInstance) {
                notify('Eroare: Grila nu este încărcată.', 'error', 2000);
                return; 
            }
            try {
                gridInstance.saveEditData()
                notify('Datele au fost salvate cu succes!', 'success', 2000);
            } catch (error: any) {
                console.error("Eroare la salvarea editării:", error);
            }
        },
        onStareIDValueChanged(e: any) {
            this.newOrganigrama.StareID = e.value
        },
        onCodValueChanged(e: any) {
            this.newOrganigrama.Cod = e.value
        },
        onNumeValueChanged(e: any) {
            this.newOrganigrama.Nume = e.value
        },
        onVersiuneValueChanged(e: any) {
            this.newOrganigrama.Versiune = e.value
        },
        onAprobDocValueChanged(e: any) {
            this.newOrganigrama.AprobareDocument = e.value
        },
        onAprobDataValueChanged(e: any) {
            this.newOrganigrama.AprobareData = e.value
        },
        onObservatiiValueChanged(e: any) {
            this.newOrganigrama.Observatii = e.value
        },
        onValidValueChanged(e: any) {
            this.newOrganigrama.Valid = e.value
        },
        onValidDataValueChanged(e: any) {
            this.newOrganigrama.ValidData = e.value
        },
        onSaveAdd() {
            if (!this.newOrganigrama.Cod || this.newOrganigrama.Cod.trim() === "") {
                notify("Vă rog să completați câmpul obligatoriu 'Cod'!", "error", 3000)
                return
            }
            if (!this.newOrganigrama.Nume || this.newOrganigrama.Nume.trim() === "") {
                notify("Vă rog să completați câmpul obligatoriu 'Nume'!", "error", 3000)
                return
            }
            if (this.newOrganigrama.StareID === null) {
                notify("Vă rog să completați câmpul obligatoriu 'Stare'!", "error", 3000)
                return
            }

            RU_Organigrama.save(this.newOrganigrama).then((org) => {
                this.addPopupVisible = false
                notify('Datele au fost salvate cu succes!', 'success', 2000)
                this.newOrganigrama = {
                    Cod: '',
                    Nume: '',
                    StareID: null,
                    Versiune: null,
                    Valid: null,
                    AprobareDocument: '',
                    AprobareData: null,
                    Observatii: '',
                    ValidData: null
                }
                this.onRefreshClick()
            }).catch((error) => {
                console.error(error)
            })
        }
    }
})
</script>